import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { admissionDateEffects } from './state/admission-date.effects';
import { admissionDateFeatureKey, admissionDateReducer } from './state/admission-date.reducer';



@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    StoreModule.forFeature(admissionDateFeatureKey, admissionDateReducer),
    EffectsModule.forFeature([admissionDateEffects])
  ]
})
export class AdmissionDateModule { }
